// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"10e2b618","452":"e50c779c","912":"423a1c30"}[chunkId] + ".chunk.js";
};